import { createSagas } from "redux-box";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import PlatformApi from "@s/api/platform";

const getErrorMessage = (err) => {
  var responseMessage =
    err &&
    err.response &&
    err.response.data &&
    err.response.data.message;

  return (
    responseMessage ||
    (err && err.error_message) ||
    (err && err.message) ||
    "Something went wrong."
  );
};

export default createSagas({
  REQUEST_PLATFORM_LIST: function*({ page }) {
    yield put({ type: "SET_PLATFORM_LIST_LOADING", value: true });
    try {
      const res = yield call(PlatformApi.getPlatformList, page || 0);
      yield put({
        type: "SET_PLATFORM_LIST",
        platforms: (res && res.result) || [],
        hasMore: !!(res && res.has_next),
        nextPage: (res && res.next_page) || 0,
      });
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({ type: "SET_PLATFORM_ERROR", value: message });
      swal("Oops!", message, "error");
    } finally {
      yield put({ type: "SET_PLATFORM_LIST_LOADING", value: false });
    }
  },

  REQUEST_CONCAT_PLATFORM_LIST: function*({ page }) {
    try {
      const res = yield call(PlatformApi.getPlatformList, page || 0);
      yield put({
        type: "CONCAT_PLATFORM_LIST",
        platforms: (res && res.result) || [],
        hasMore: !!(res && res.has_next),
        nextPage: (res && res.next_page) || 0,
      });
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({ type: "SET_PLATFORM_ERROR", value: message });
      swal("Oops!", message, "error");
    }
  },

  CREATE_PLATFORM: function*({ data }) {
    yield put({ type: "SET_PLATFORM_SUBMITTING", value: true });
    yield put({ type: "SET_PLATFORM_ERROR", value: "" });
    try {
      yield call(PlatformApi.createPlatform, data);
      yield put({ type: "REQUEST_PLATFORM_LIST", page: 0 });
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "CLEAR_PLATFORM_FORM_STATE" });
      swal("Done", "Platform created successfully", "success");
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({ type: "SET_PLATFORM_ERROR", value: message });
    } finally {
      yield put({ type: "SET_PLATFORM_SUBMITTING", value: false });
    }
  },

  UPDATE_PLATFORM: function*({ data }) {
    yield put({ type: "SET_PLATFORM_SUBMITTING", value: true });
    yield put({ type: "SET_PLATFORM_ERROR", value: "" });
    try {
      yield call(PlatformApi.updatePlatform, data.id, data.payload);
      yield put({ type: "REQUEST_PLATFORM_LIST", page: 0 });
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "CLEAR_PLATFORM_FORM_STATE" });
      swal("Done", "Platform updated successfully", "success");
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({ type: "SET_PLATFORM_ERROR", value: message });
    } finally {
      yield put({ type: "SET_PLATFORM_SUBMITTING", value: false });
    }
  },

  REQUEST_CONTENT_POLICY_SCHEMA: function*() {
    yield put({ type: "SET_CONTENT_POLICY_SCHEMA_LOADING", value: true });
    try {
      const res = yield call(PlatformApi.getContentPolicySchema);
      yield put({ type: "SET_CONTENT_POLICY_SCHEMA", schema: res.result });
    } catch (err) {
      // schema load failure is non-fatal — rule-builder just won't show choices
    } finally {
      yield put({ type: "SET_CONTENT_POLICY_SCHEMA_LOADING", value: false });
    }
  },
});
